// extracted by mini-css-extract-plugin
module.exports = {"productCatalogCardHolder":"main_productCatalogCardHolder___lAOJ"};